import React, { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { Megaphone, Radar, Share2, X } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";

export default function SubmitGate() {
  const { t, user, checkingAuth } = useApp();
  const [open, setOpen] = useState(false);
  if (checkingAuth) return null;
  if (!user) return <Navigate to="/auth" />;
  const url = window.location.origin;
  const text = t("inviteText", { url });
  const native = async () => { if (navigator.share) { try { await navigator.share({ title: "Soul Radar", text, url }); return; } catch (err) { if (err?.name === "AbortError") return; console.warn("share failed, falling back to clipboard", err); } } await navigator.clipboard.writeText(text); toast.success(t("linkCopied")); };
  return (
    <div className="max-w-2xl mx-auto px-4 md:px-6 py-10" data-testid="submit-gate">
      <div className="eyebrow text-primary">{t("submitEvent")}</div>
      <h1 className="font-display uppercase text-4xl md:text-5xl tracking-tighter border-b border-foreground pb-3">{t("gateTitle")}</h1>
      <div className="mt-6 grid gap-3">
        <Link to="/create-event" className="gg-card p-5 flex items-start gap-4 hover:border-primary transition-colors" data-testid="gate-organizer">
          <Megaphone className="w-6 h-6 text-primary shrink-0 mt-1" />
          <div><div className="font-display uppercase text-2xl leading-tight">{t("gateOrganizer")}</div><p className="text-sm text-muted-foreground mt-1">{t("gateOrganizerHint")}</p></div>
        </Link>
        <button onClick={() => setOpen(true)} className="gg-card p-5 flex items-start gap-4 text-left hover:border-primary transition-colors" data-testid="gate-discovered">
          <Radar className="w-6 h-6 text-primary shrink-0 mt-1" />
          <div><div className="font-display uppercase text-2xl leading-tight">{t("gateDiscovered")}</div><p className="text-sm text-muted-foreground mt-1">{t("gateDiscoveredHint")}</p></div>
        </button>
      </div>
      {open && (
        <div className="fixed inset-0 z-50 bg-black/60 flex items-end sm:items-center justify-center" onClick={() => setOpen(false)} data-testid="invite-dialog">
          <div onClick={e => e.stopPropagation()} className="gg-card bg-background p-5 w-full sm:max-w-md">
            <div className="flex items-center justify-between"><h3 className="font-display uppercase text-2xl">{t("inviteTitle")}</h3><button onClick={() => setOpen(false)} className="gg-icon-btn" aria-label="close"><X className="w-5 h-5" /></button></div>
            <p className="mt-3 text-sm">{t("inviteBody")}</p>
            <p className="mt-3 p-3 border border-foreground/30 text-sm italic" data-testid="invite-preview">{text}</p>
            <div className="mt-4 flex flex-col gap-2">
              <a href={`https://wa.me/?text=${encodeURIComponent(text)}`} target="_blank" rel="noreferrer noopener" className="gg-btn" data-testid="invite-whatsapp">WhatsApp</a>
              <a href={`mailto:?subject=${encodeURIComponent(t("inviteSubject"))}&body=${encodeURIComponent(text)}`} className="gg-btn" data-testid="invite-mail">{t("email")}</a>
              <button onClick={native} className="gg-btn-primary" data-testid="invite-native"><Share2 className="w-4 h-4" />{t("share")}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
